export class TableRequest {
}
export class TableFilter {
}
export var OrderType;
(function (OrderType) {
    OrderType["Asc"] = "Asc";
    OrderType["Desc"] = "Desc";
})(OrderType || (OrderType = {}));
